import { render } from "./projectServices.vue?vue&type=template&id=6f1407cb"
import script from "./projectServices.vue?vue&type=script&lang=js"
export * from "./projectServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__